import React from 'react';

import { toTitle } from '../../base2/utils';

import { Badge } from './badge';

interface Asset {
  name: string;
  type: string;
}

interface AssetHeaderProps {
  asset: Asset;
  handleRemove?: (() => void) | null;
  handleEdit?: (() => void) | null;
}

export function AssetHeader({ asset, handleRemove = null, handleEdit = null }: AssetHeaderProps) {
  return (
    <div className="asset-header">
      <div className="info">
        <span className="asset-name">{asset.name}</span>
      </div>
      <div className="actions-container">
        { asset.type && <Badge value={toTitle(asset.type).toUpperCase()} />}
        <div className="actions">
          <span 
            className="material-symbols-outlined edit"
            onClick={handleEdit}
          >
              edit
          </span>
          <span 
            className="material-symbols-outlined delete" 
            onClick={handleRemove}
          >
              close
          </span>
        </div>
      </div>
    </div>
  );
}
